module.exports = __webpack_public_path__ + "static/img/er_cb.399fa4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/er_cb.jpg
// module id = 1G3k
// module chunks = 1